import { render, staticRenderFns } from "./WikiAccessAnalytics.vue?vue&type=template&id=5c776d55"
import script from "./WikiAccessAnalytics.vue?vue&type=script&lang=ts"
export * from "./WikiAccessAnalytics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports